<template>
  <div>
    <div class="instructions">
      <h1>Anleitung</h1>
      <!--<h4>Anleitung</h4>-->
      
      <p>Loggen Sie sich mit den im alten System gültigen Zugangsdaten ein.</p>

      <p>Sie sehen dann den Dienstplan für ihren Bezirk.<br><small>Der Dienstplan lässt
          sich durchblättern. Nutzen Sie dazu die an
          der unteren Seite befindlichen Möglichkeiten.</small></p>
<p>
      Für Anpassungen klicken Sie einen Dienst an und </p>
      <p>
      - Wählen einen anderen Namen aus<br>
      - und/oder tragen Sie in das Feld Nachricht eine dienstbezügliche Nachricht ein<br>
      - Klicken Sie auf Absenden </p>
<p></p>
      <p>Wir erhalten dann die Änderung und nehmen die Einstellungen nach Sichtung für Sie vor.</p>
      <p>Für dringliche Änderung rufen Sie uns bitte an unter <a href="tel:01805073100">01805 0731 00</a>
      <br><small>*Festnetzpreis 14 ct/min; Mobilfunkpreise maximal 42 ct/min</small></p>
      
    </div>
  </div>
</template>  
<script setup>
</script>

<style scoped>
.instructions {
  color: #4b4b4b;
  font-size: 150%;
  
}
</style>
